export default function setupDataModel() {
	const { findHtmlEls, getClosest } = pm.utils.dom;

	const modelKeyDataName = "data-model-key";
	const modelValueSelector = "[data-model-value]";

	document.addEventListener("DOMContentLoaded", handleDocumentReady);
	document.addEventListener("click", handleDocumentClick);

	function handleDocumentReady(_e: Event) {
		const buttons = findHtmlEls(modelValueSelector);

		buttons.forEach(function (switchButton) {
			if (!switchButton.classList.contains("is-active")) return;
			handleCondition(switchButton);
		});
	}

	function handleDocumentClick(e: MouseEvent) {
		const target = e.target;
		if (!(target instanceof Element)) return;

		const button = getClosest(target, modelValueSelector);
		if (!button) return;

		const parentEl = button.parentElement;

		if (!parentEl || !parentEl.hasAttribute(modelKeyDataName)) {
			return;
		}

		e.preventDefault();

		const buttons = findHtmlEls(parentEl, modelValueSelector);
		if (!buttons.length) return;

		buttons.forEach(function (switchButton) {
			const modelKey = parentEl.dataset.modelKey;
			if (!modelKey) return;

			if (switchButton === button) {
				switchButton.classList.add("is-active");

				pm.event.emit("data_model_switched_on", {
					key: modelKey,
					value: switchButton.dataset.modelValue
						? switchButton.dataset.modelValue
						: "",
				});
			} else {
				switchButton.classList.remove("is-active");

				pm.event.emit("data_model_switched_off", {
					key: modelKey,
					value: switchButton.dataset.modelValue
						? switchButton.dataset.modelValue
						: "",
				});
			}
		});

		handleCondition(button);
	}

	function handleCondition(button: HTMLElement) {
		const parentEl = button.parentElement;
		const key = parentEl?.dataset.modelKey;
		const value = button.dataset.modelValue;
		if (!key || !value) return;

		handleShowIf(key, value);
		handleClassModel(key, value);
	}

	function handleShowIf(key: string, value: string) {
		const listenerEls = findHtmlEls('[data-show-if-key="' + key + '"]');
		if (!listenerEls.length) return;

		listenerEls.forEach(function (listenerEl) {
			if (listenerEl.dataset.showIfValue === value) {
				listenerEl.classList.remove("is-hidden");
			} else {
				listenerEl.classList.add("is-hidden");
			}
		});
	}

	function handleClassModel(key: string, value: string) {
		const listenerEls = findHtmlEls('[data-class-model="' + key + '"]');
		if (!listenerEls.length) return;

		const modelValuesEls = findHtmlEls(
			"[" + modelKeyDataName + '="' + key + '"] ' + modelValueSelector,
		);

		let modelValues: Array<string> = [];

		modelValuesEls.forEach(function (modelValueEl) {
			const modelValue = modelValueEl.dataset.modelValue
				? modelValueEl.dataset.modelValue
				: "";
			modelValues.push(modelValue);
		});

		listenerEls.forEach(function (listenerEl) {
			if (listenerEl.hasAttribute("data-render-class-if-key")) {
				const renderClassIfKey = listenerEl.dataset.renderClassIfKey;
				let className = listenerEl.dataset.renderClass;

				if (renderClassIfKey === value) {
					if (className) listenerEl.classList.add(className);
				} else {
					if (className) listenerEl.classList.remove(className);
				}
			} else {
				modelValues.forEach(function (modelValue) {
					let className = listenerEl.dataset.renderClass;
					if (!className) return;

					className = className.replace("{{value}}", modelValue);

					if (modelValue === value) {
						listenerEl.classList.add(className);
					} else {
						listenerEl.classList.remove(className);
					}
				});
			}
		});
	}
}
